import { request, serviceUrl } from "@/utils/request";

/** 站点能源自给率排名及汇总 */
export function energySelfSufficiencyRate() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/energySelfSufficiencyRate`,
  });
}

/** 今日全市能耗总览 JSON */
export function getTodayEnergy() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/todayEnergy`,
  });
}

/** 与同 URL 协商返回 Excel 二进制时可用；若为 JSON bytes 或未配置导出，则由页面降级 CSV */
export function exportTodayEnergyFile() {
  return request({
    method: "get",
    url: `${serviceUrl.emsService}/photovoltaic/todayEnergy`,
    responseType: "arraybuffer",
  });
}

/** 近七日能耗趋势 */
export function getWeeklyTrend() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/getWeeklyTrend`,
  });
}

/** 导出近七日能耗趋势（Excel），GET 二进制流 */
export function exportWeeklyTrendFile() {
  return request({
    method: "get",
    url: `${serviceUrl.emsService}/photovoltaic/exportWeeklyTrend`,
    responseType: "arraybuffer",
  });
}

/** 设备动力环境监测列表 */
export function getSiteEnvMonitor() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/site-env-monitor`,
  });
}

/** 绿色效益（累计减排、等效植树等） */
export function getGreenBenefit() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/greenBenefit`,
  });
}

/** 能源占比：光伏 / 市电 */
export function getEnergyRatio() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/energyRatio`,
  });
}

/** 站点能耗排名 */
export function getSiteEnergyRank() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/siteEnergyRank`,
  });
}

/** 地图：站点 / 汇聚点节点列表 */
export function getSiteNodeList() {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/site-node-list`,
  });
}

/** 地图：点击站点详情 */
export function getSiteDetail(spaceId) {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/site-detail`,
    params: { spaceId },
  });
}

/** 地图：点击汇聚点详情 */
export function getConvergencePointDetail(spaceId) {
  return request({
    url: `${serviceUrl.emsService}/photovoltaic/convergence-point-detail`,
    params: { spaceId },
  });
}
